import { DocumentStorageContextProvider } from 'framework/documentStorage';
import React from 'react';
import useVendorDocumentsService from './useVendorDocumentsService';

const VendorDocumentContextTemplate = ({ children }: { children: React.ReactNode }) => {
  const actions = useVendorDocumentsService();

  return <DocumentStorageContextProvider value={actions}>{children}</DocumentStorageContextProvider>;
};

export default VendorDocumentContextTemplate;
